module.exports = __webpack_public_path__ + "img/text_record_list.43f9cef6.png";